module.exports = __webpack_public_path__ + "img/coffee.660d598f.png";